import { render, staticRenderFns } from "./fccBannersCadastro.vue?vue&type=template&id=4606d3ca"
import script from "./fccBannersCadastro.vue?vue&type=script&lang=js"
export * from "./fccBannersCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports